import { StandardEvents } from '@shopify/events';

/**
 * Aviso del combo pantalon + camiseta — OWL COLOMBIA (2026-08-13)
 *
 * NO calcula precios. El precio del combo lo calcula Liquid en el servidor
 * (blocks/combo-notice.liquid). Cuando el cliente cambia de horma o de talla,
 * el tema vuelve a renderizar la seccion y reparte el HTML nuevo por el evento
 * productSelect; este elemento solo se busca a si mismo en ese HTML por su
 * data-block-id y reemplaza su contenido.
 *
 * Es el mismo patron que usa assets/product-price.js. Se copio a proposito en
 * vez de inventar otro: si Shopify cambia el mecanismo, los dos se arreglan igual.
 */
class ComboNotice extends HTMLElement {
  #section = null;

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    if (!this.#section) return;
    this.#section.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    if (!this.#section) return;
    this.#section.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#section = null;
  }

  /**
   * @param {CustomEvent & { promise: Promise<{ detail: any }> }} event
   */
  #handleProductSelect = (event) => {
    // Las tarjetas de producto emiten el mismo evento dentro de la ficha
    // (recomendados, quick add). Sin este guardia, el aviso de la ficha se
    // sobrescribiria con el de otro producto.
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const fresco = html.querySelector(`combo-notice[data-block-id="${this.dataset.blockId}"]`);

        // Si el producto nuevo no participa en el combo, Liquid no renderiza
        // el bloque: hay que vaciar el aviso viejo en vez de dejarlo mintiendo.
        if (!fresco) {
          this.replaceChildren();
          return;
        }

        this.innerHTML = fresco.innerHTML;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[combo-notice] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('combo-notice')) {
  customElements.define('combo-notice', ComboNotice);
}

